import { Box, Flex, mediaQueries, theme } from '@lce/slice';
import styled from 'styled-components';

export const Container = styled(Box).attrs({
  mt: [0, 0, '32px'],
})`
  background-color: ${() => theme.colors.white};
  overflow: hidden;
  margin-bottom: 16px;
`;

export const Content = styled(Flex)`
  margin: '0 auto';
  padding: 8px;
  justify-content: center;
`;

export const DealsWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: 0;

  ${mediaQueries[2]} {
    grid-template-columns: auto auto;
    grid-row-gap: 36px;
    grid-column-gap: 20px;
  }
`;
